import type { ComponentPropsWithRef } from 'react';
import SkapaText from '@ingka/text';
import '@ingka/text/dist/style.css';
import styled from 'styled-components';

type TextProps = ComponentPropsWithRef<typeof SkapaText>;

// Inherit font-weight and color from parent to support styled-components overrides
const StyledText = styled(SkapaText)`
  font-weight: inherit;
  color: inherit;
`;

const Text = (props: TextProps) => <StyledText {...props} />;

export default Text;
